import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const easeOut = [0.22, 1, 0.36, 1];

// Section-level scroll-reveal wrapper
export const Reveal = ({ children, delay = 0, y = 40, className = '', once = true }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: '-80px' }}
      transition={{ duration: 0.9, delay, ease: easeOut }}
    >
      {children}
    </motion.div>
  );
};

// Masked line-by-line reveal — each line clips its overflow and slides up
export const MaskedLines = ({ lines, className = '', delayStart = 0.15, stagger = 0.12 }) => {
  const reduce = useReducedMotion();
  return (
    <div className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className="block"
            initial={reduce ? { y: 0 } : { y: '110%' }}
            animate={{ y: 0 }}
            transition={{
              duration: 0.95,
              delay: delayStart + i * stagger,
              ease: easeOut,
            }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </div>
  );
};

// Simple fade-in for supporting text/elements
export const FadeIn = ({ children, delay = 0, className = '' }) => {
  const reduce = useReducedMotion();
  if (reduce) return <div className={className}>{children}</div>;
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.9, delay, ease: easeOut }}
    >
      {children}
    </motion.div>
  );
};
